import React, {useState, useEffect} from 'react';
import {TituloMenu,ColFlex, RowStyle} from './style'
import {Row, Col, List, Card, Button} from 'antd'
import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';
import ProductModalForm from './forms/InfoProductModalForm';
import {actionGetConfigTarifasRequest, actionGetProducts, openEditProductModal, openNewProductModal } from '../../store/acciones/accionesProductos';
import { PDFDownloadLink } from '@react-pdf/renderer';
import GeneratePDF from './widgets/GeneratePDFDos';
import Search from 'antd/lib/input/Search';
import { InputNumber } from 'antd';
import plantillaProductos from './widgets/import_productos.xlsx'

const Productos = (props) => {
//const [visible, showModal] = useState(false)
const [filters, setFilters] = useState(null)

let productos = useSelector(state => state.reducerProductos.entities);
let configTarifas = useSelector(state => state.reducerProductos.configTarifas);
let totalProducts = useSelector(state => state.reducerProductos.total);
let usuario =useSelector(state=>state.reducerUsuario.usuario)
const dispatch = useDispatch();


const [isClient, setIsClient] = useState(false)
const [tarifas, setTarifas]=useState({
    tarjeta_debito:null,
    tarjeta_credito:null,
    pago_tres_meses:null,
    pago_seis_meses:null
})


useEffect(() => {
    console.log('se renderizo')
    setTimeout(()=>{
        setIsClient(true)
      }, 1000);
}, [productos])

  useEffect(()=>{
    dispatch(actionGetProducts(1,filters))
    dispatch(actionGetConfigTarifasRequest())
  },[dispatch,filters])

    useEffect(()=>{
        console.log("hola mundo")
        if(configTarifas){
            setTarifas({
                tarjeta_debito:configTarifas.tarjeta_debito,
                tarjeta_credito:configTarifas.tarjeta_credito,
                pago_tres_meses:configTarifas.pago_tres_meses,
                pago_seis_meses:configTarifas.pago_seis_meses
            })
        }

    },[configTarifas])

    function onChange(key, value) {
        setTarifas({ ...tarifas, [key]: value })
    }

    function CalcularPorcentaje(tipoTarifa, tarifa){
        if(tipoTarifa){
            return tarifa * (tipoTarifa/100) + tarifa
        }
        else return tarifa
    }

    // This componente filter the first img in the array excluding pdf items
    const ImageProduct = ({imageItems,itemName}) => {
       const getFirstImage= imageItems.filter(imgItem => imgItem.image_product.indexOf(".png") > -1 || imgItem.image_product.indexOf(".jpg") > -1 || imgItem.image_product.indexOf(".jpeg") > -1)[0]
       return  getFirstImage ? <img src={getFirstImage.image_product} style={{width:"100%"}} alt ={getFirstImage.id} />:"Sube una Imagen"
    }

    return (
        <>
            <TituloMenu>Productos</TituloMenu>
            <RowStyle type="flex" justify="space-around" align="middle">
                <ColFlex xl={6} lg={6} md={6} sm={24} xs={24}>
                    <Search placeholder="nombre, clave, descripcion precio" onSearch={value => setFilters(value)} enterButton />
                </ColFlex>
                {usuario.is_superuser && <>
                    <ColFlex xl={4} lg={24} md={24} sm={24} xs={24}>
                        <Button type="primary" icon="plus" size="default" onClick={() => {
                            dispatch(openNewProductModal());
                        }}>
                            Agregar Producto
                        </Button>
                    </ColFlex>
                    <ColFlex xl={4} lg={24} md={24} sm={24} xs={24}>
                        <Button href={plantillaProductos} type="primary" icon="file-excel" size="default">Descargar Plantilla</Button>
                    </ColFlex>
                </>}
                
                {/* <ColFlex xl={4} lg={24} md={24} sm={24} xs={24}>
                    <ImportProducts/>
                </ColFlex> */}
                <ColFlex xl={4} lg={4} md={24} sm={24} xs={24}>
                    {isClient && (
                        <PDFDownloadLink document={
                            <GeneratePDF productos={productos} />
                        }
                            fileName="printProducts.pdf"
                        >
                            {({ blob, url, loading, error }) => (loading ?
                                <Button type="primary" icon="plus" size="default" >
                                    Cargando Productos
                                </Button> :
                                <Button type="primary" icon="printer" size="default"  >
                                    Imprimir esta página
                                    
                                </Button>)}
                        </PDFDownloadLink>
                    )}
                </ColFlex>
              
            </RowStyle>
            {usuario.is_superuser&& <Card title="Variables de tarifas" style={{ width: "100%" }}>
                <RowStyle type="flex" justify="space-around" align="middle">
                    <ColFlex xl={4} lg={4} md={4} sm={24} xs={24} >
                        <div style={{ marginRight: 5, fontWeight: "bold", fontSize: 16 }}>Debito</div>
                        <InputNumber
                            //defaultValue={100}
                            value={tarifas.tarjeta_debito}
                            min={0}
                            max={100}
                            formatter={value => `${value}%`}
                            parser={value => value.replace('%', '')}
                            onChange={(value)=>onChange('tarjeta_debito',value)}
                        />
                    </ColFlex>
                    <ColFlex xl={5} lg={5} md={5} sm={24} xs={24} >
                        <div style={{ marginRight: 10, fontWeight: "bold", fontSize: 16 }}>Credito</div>
                        <InputNumber
                            //defaultValue={100}
                            value={tarifas.tarjeta_credito}
                            min={0}
                            max={100}
                            formatter={value => `${value}%`}
                            parser={value => value.replace('%', '')}
                            onChange={(value)=>onChange('tarjeta_credito',value)}
                        />
                    </ColFlex>
                    <ColFlex xl={5} lg={5} md={5} sm={24} xs={24} >
                        <div style={{ marginRight: 10, fontWeight: "bold", fontSize: 16 }}>Tres Meses </div>
                        <InputNumber
                            //defaultValue={100}
                            value={tarifas.pago_tres_meses}
                            min={0}
                            max={100}
                            formatter={value => `${value}%`}
                            parser={value => value.replace('%', '')}
                            onChange={(value)=>onChange('pago_tres_meses',value)}
                        />
                    </ColFlex>
                    <ColFlex xl={5} lg={5} md={5} sm={24} xs={24} >
                        <div style={{ marginRight: 10, fontWeight: "bold", fontSize: 16 }}>Sesis Meses</div>
                        <InputNumber
                            // defaultValue={100}
                            value={tarifas.pago_seis_meses}
                            min={0}
                            max={100}
                            formatter={value => `${value}%`}
                            parser={value => value.replace('%', '')}
                            onChange={(value)=>onChange('pago_seis_meses',value)}
                        />
                    </ColFlex>
                    {/* <ColFlex xl={4} lg={4} md={4} sm={24} xs={24}>
                        <Button type="primary" icon="plus" size="default" onClick={()=>dispatch(actionEditConfigTarifasRequest(tarifas,configTarifas.id))} >
                            Editar Variables
                        </Button>
                    </ColFlex> */}
                </RowStyle>
            </Card> }
           

            <Row type="flex" justify="space-around" align="middle">
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <List
                     pagination={{
                        showQuickJumper:true,
                        size:"small",
                        total:totalProducts,
                        onChange: page => {
                            dispatch(actionGetProducts(page,filters))
                        },
                        pageSize: 50,
                        position:'top',
                        
                      }}
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 1,
                            lg: 1,
                            xl: 1,
                            xxl: 1,
                        }}
                        dataSource={productos}
                        renderItem={item =>
                            (
                            <List.Item>
                                <Card>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col xl={1} lg={2} md={24} sm={24} xs={24}>
                                            {
                                                item.image_product && item.image_product.length>0 ? <ImageProduct imageItems={item.image_product} itemName={item.nombre_producto}/>: "No existe Imagen"
                                            }                                       
                                        </Col>
                                        <Col xl={4} lg={4} md={24} sm={24} xs={24} style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                                            {item.nombre_producto &&  <span style={{ fontSize: 14, fontWeight: "700", letterSpacing: "1.5px", color: "#222831" }}>{item.nombre_producto}</span>}
                                            {
                                                item.clave_producto && 
                                                <div>
                                                    <span style={{ fontSize: 10, fontWeight: "700", letterSpacing: "1px", color: "#222831" }}> Clave producto: {item.clave_producto}</span>
                                                </div>
                                            }
                                            {
                                                item.descripcion_producto && 
                                                <div>
                                                    <span style={{ fontSize: 10, fontWeight: "700", letterSpacing: "1px", color: "#222831" }}>{item.descripcion_producto}</span>
                                                </div>
                                            }
                                        </Col>
                                        <Col xl={3} lg={3} md={24} sm={24} xs={24} style={{display:"flex",flexDirection:"column", justifyContent:"flex-start"}}>
                                            <span>Publico</span>
                                            <span style={{fontSize:14, fontWeight:"800", letterSpacing:"1px", margin:"10 0 10 0"}}> <NumberFormat value={item.precio_publico} displayType={'text'}  thousandSeparator={true} prefix={'$'} decimalScale={2}/></span> 
                                        </Col>
                                        <Col xl={3} lg={3} md={24} sm={24} xs={24} style={{display:"flex",flexDirection:"column", justifyContent:"flex-start"}}>
                                            <span>Debito</span>
                                            <span style={{fontSize:14, fontWeight:"800", letterSpacing:"1px", margin:"10 0 10 0"}}> <NumberFormat value={CalcularPorcentaje(tarifas.tarjeta_debito, item.precio_publico)} displayType={'text'}  thousandSeparator={true} prefix={'$'} decimalScale={2}/></span> 
                                        </Col>
                                        <Col xl={3} lg={3} md={24} sm={24} xs={24} style={{display:"flex",flexDirection:"column", justifyContent:"flex-start"}}>
                                            <span>Credito</span>
                                            <span style={{fontSize:14, fontWeight:"800", letterSpacing:"1px", margin:"10 0 10 0"}}> <NumberFormat value={CalcularPorcentaje(tarifas.tarjeta_credito,item.precio_publico)} displayType={'text'}  thousandSeparator={true} prefix={'$'} decimalScale={2}/></span> 
                                        </Col>
                                        <Col xl={3} lg={3} md={24} sm={24} xs={24} style={{display:"flex",flexDirection:"column", justifyContent:"flex-start"}}>
                                            <span>Credito 3 meses</span>
                                            <span style={{fontSize:14, fontWeight:"800", letterSpacing:"1px", margin:"10 0 10 0"}}> <NumberFormat value={CalcularPorcentaje(tarifas.pago_tres_meses,item.precio_publico)}  displayType={'text'}  thousandSeparator={true} prefix={'$'} decimalScale={2}/></span> 
                                        </Col>
                                        <Col xl={3} lg={3} md={24} sm={24} xs={24} style={{display:"flex",flexDirection:"column", justifyContent:"flex-start"}}>
                                            <span>Credito 6 meses</span>
                                            <span style={{fontSize:14, fontWeight:"800", letterSpacing:"1px", margin:"10 0 10 0"}}> <NumberFormat value={CalcularPorcentaje(tarifas.pago_seis_meses,item.precio_publico)}  displayType={'text'}  thousandSeparator={true} prefix={'$'} decimalScale={2}/></span> 
                                        </Col>
                                        <Col xl={1} lg={1} md={24} sm={24} xs={24} style={{display:"flex",flexDirection:"column", justifyContent:"flex-start"}}>
                                            <span style={{fontSize:14, fontWeight:"800", letterSpacing:"1px"}}>{item.medida_producto}</span> 
                                        </Col>
                                        <Col xl={1} lg={1} md={24} sm={24} xs={24} style={{display:"flex", flexDirection:"row", justifyContent:"space-around", alignItems:"center"}}>
                                            <Button type="primary" icon="edit"  size="small" onClick={() => {
                                                dispatch(openEditProductModal(item));
                                            }} ></Button>
                                            {/* <Button type="primary" icon="download"  size="small" >Descargar</Button>
                                            <Link to={`${props.match.url}/${item.id}`} >
                                                <Button type="primary" icon="file" size="small"  >Ver</Button>
                                            </Link> */}
                                        </Col>
                                    </Row>
                                    
                                </Card>
                            </List.Item>
                        )}
                    />
                    <ProductModalForm/>
                </Col>
            </Row>
        </>
    );
};

export default Productos;